import React from 'react'

const Header = () => {
  return (
    <header>
     
        <section id="sect1" class="sect">
          <video src="https://www.trenquelauquen.gov.ar/wordpress/wp-content/uploads/Turismo-Trenque-Lauquen2.mp4" autoplay="true" muted="true" loop="true"></video>
          <img src="https://www.trenquelauquen.gov.ar/wordpress/wp-content/uploads/Presupuesto-Participativo01.png" alt='Presupuesto Participativo' width={500} />
        </section>        
    
    </header>
  )
}

export default Header